import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { MdsSpinnerComponent } from '@medpacesoftwaredevelopment/designsystem';

@Component({
    selector: 'medpace-loading-card',
    templateUrl: './loading-card.component.html',
    styleUrls: ['./loading-card.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MdsSpinnerComponent],
})
export class LoadingCardComponent {
    diameter: InputSignal<number> = input(200);
}
